// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__AHE9x","input":"Switch_input__5yY-t","inner":"Switch_inner__A3Wdo","box":"Switch_box__7jis-"};